import axios from "axios";

export const registerEmail = async (email, role) => {
  console.log('checked');
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/register-email`,
        { email, role }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const verifyEmail = async (otp, email) => {
    console.log(otp, email);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/verify-email`,
        { otp, email }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const signUp = async (
    firstName,
    lastName,
    organization,
    email,
    idNumber,
    country,
    address,
    phoneNumber,
    password,
    role,
    countryCode,
    verifierType
  ) => {
    console.log({
      firstName,
    lastName,
    organization,
    email,
    idNumber,
    country,
    address,
    phoneNumber,
    password,
    role,
    countryCode,
    verifierType
    });
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/sign-up`,
        {
        firstName,
    lastName,
    organization,
    email,
    idNumber,
    country,
    address,
    phoneNumber,
    password,
    role,
    countryCode,
    verifierType
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const login = async (
    email,
    password
  ) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/log-in`,
        {
        email,
        password
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  
  export const forgotPassword = async (
    email
    ) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/forget-password`,
       {
        email
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  
  export const resetPassword = async (
    email,
    password
    ) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/open/v1/forgot-password-reset`,
       {
        email,
        password
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const resendOtp = async (email) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/resend-otp`,
        { email }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };